
import VText from "components/VText";
import { View, Image, StyleSheet } from "react-native";
import { fp, spH, spV, wp, hp } from "utils/normalizeV2";
import Buttons from "components/Buttons";
import { Images } from "assets";
import { useLocalSearchParams, useRouter } from "expo-router";

export default function setPreferencesForYou() {
    const router = useRouter();
    const local = useLocalSearchParams();
    const gender = local?.gender ?? "female";
    const handleSetPreferences = () => {
        router.push(`/my-preferences?gender=${gender}`);
    };

   


  


    return (
            <View style={styles.container}>
                <View style={styles.contentContainer}>
                    <View style={styles.textContainer}>
                        <VText style={styles.contentHeading}>FOR YOU</VText>
                        <VText style={styles.contentSubHeading}>
                            Welcome to your personalized product feed of pieces and looks custom-curated to fit your style
                        </VText>
                        <Buttons
                            containerStyle={styles.buttonContainer}
                            text="SET PREFERENCES"
                            textStyle={styles.buttonText}
                            onPress={handleSetPreferences}
                        />
                    </View>
                    <View style={styles.imageContainer}>
                        <Image accessibilityLabel="For You Image 1" resizeMode="contain" source={Images.forYouImage1} style={styles.imageStyle} />
                        <Image accessibilityLabel="For You Image 2" resizeMode="contain" source={Images.forYouImage2} style={styles.imageStyle} />
                    </View>
                </View>
            </View>
    );
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: spH(40),
        paddingVertical: spV(30),
        alignItems: "center",
        backgroundColor: "black",
        height: "600px",
    },
    contentContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: spV(40),
        borderBottomWidth: 1,
        borderColor: "#21242729",
    },
    textContainer: {
        width: wp(550),
        alignItems: "flex-start",
        justifyContent: "flex-start",
        paddingTop: spV(150),
    },
    contentHeading: {
        fontSize: fp(32),
        fontWeight: "600",
        color: "white",
        fontFamily: "LibreBodoni",
    },
    contentSubHeading: {
        fontSize: fp(16),
        fontWeight: "300",
        paddingVertical: spV(15),
        color: "white",
        width: wp(380),
    },
    buttonContainer: {
        backgroundColor: "#FFFFFF4D",
        width: wp(181),
        height: hp(36),
    },
    buttonText: {
        color: 'white',
        fontSize: fp(15),
        fontFamily: "JosefinSans",
        fontWeight: "300",
    },
    imageContainer: {
        width: wp(550),
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-evenly",
        paddingHorizontal: spH(100),
    },
    imageStyle: {
        width: wp(218),
        height: hp(435),
    },
});
